module.exports = __webpack_public_path__ + "img/passed.59e9d220.jpeg";